module.exports = __webpack_public_path__ + "static/sdg-48e942061f58a694e6ce617ba6dc9cc2.png";